module.exports = __webpack_public_path__ + "static/Athletics-Medium-2dd1e54b9417a155f5ff2e995f4193d1.otf";